<i18n>
{
"no": {
"areYouSure": "Er du sikkker?",
"info": "Hvis du avbryter nå, vil du bli bedt om å bekrefte identiteten din ved neste innlogging til denne tjenesten.",
"info2": "Fordi du allerede har en Telenor ID, kan du fortsatt bruke den til å logge inn til andre tjenester som ikke krever bekreftelse av din identitet ved fødselsnummer.",
"yesIWantToCancel": "Ja, jeg vil avbryte",
"back": "Tilbake"
},
"en": {
"areYouSure": "Are you sure?",
"info": "If you cancel now, you will be asked to confirm your identity the next time you log into this service.",
"info2": "Since you already have a Telenor ID, you can still use it to log in to other services that do not require proof of identity with your national ID number.",
"yesIWantToCancel": "Yes, I want to cancel",
"back": "Back"
}
}
</i18n>

<template>
  <InfoScreen>
    <TnHeading type="h1" size="m" class="margin-bottom-l">{{ t('areYouSure') }}</TnHeading>
    <TnParagraph class="margin-bottom-l">{{ t('info') }}</TnParagraph>
    <TnParagraph size="s" class="margin-bottom-l">{{ t('info2') }}</TnParagraph>

    <TnButton
      secondary
      block
      href="/account/logout"
      target="_blank"
      :text="t('yesIWantToCancel')"
    />

    <BackLink :text="t('back')" />
  </InfoScreen>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { TnButton, TnHeading, TnParagraph } from '@telenornorgeinternal/telegrafen-vue3-core';

import InfoScreen from '@/components/InfoScreen.vue';
import BackLink from '@/components/BackLink.vue';

const { t } = useI18n();
</script>
